<template>
   	<div class="banner">
   		<div class="swiper-container">
		    <div class="swiper-wrapper">
		        <div class="swiper-slide"><img src="../assets/banner01.jpg" url="plist/list/122950" @click="toPlistPage($event)"/></div>
		        <div class="swiper-slide"><img src="../assets/banner02.jpg" url="plist/list/122774" @click="toPlistPage($event)"/></div>
		        <div class="swiper-slide"><img src="../assets/banner03.jpg" url="plist/list/122759" @click="toPlistPage($event)"/></div>
		    </div>
		    <!-- 如果需要分页器 -->
		    <div class="swiper-pagination"></div>
		</div>
   	</div>
</template>

<script>
import jq from '../assets/swiper-3.4.0.min.js'
 export default {
    data () {
      return {
      	
      }
    },
    mounted:function(){
    	var swiper = new Swiper('.swiper-container',{
			 // 如果需要分页器
			pagination: '.swiper-pagination',
			loop:true,
			autoplay:3000,
			autoplayDisableOninteraction:false,
		});
    },
    methods: {
      toPlistPage:function(e){
      	var url=e.target.attributes.url.value;
      	this.$store.commit('setGuodu',true);
      	var _this=this;
		$.ajax({ 
			type:"get",
			url: "https://www.xi-g.com/api/agent_api/newSongList?url="+url,
			success: function(data){
				var div = document.createElement('div');
				div.innerHTML = data;
				var list = div.querySelectorAll('.panel-songslist-item');
				var songList = [];
				for(var i=0;i<list.length;i++){
					var song={};
					song.title=list[i].querySelector('.panel-songs-item-name span').textContent;
					song.hash=list[i].id.substr(6);
					songList.push(song);
				}
				setTimeout(function(){
					var rankTime=div.querySelector('.page-title').textContent;
					var plistText=div.querySelector('#introBox p').textContent;
					var rankImgUrl=div.querySelector('#imgBoxInfo img').getAttribute('src');
					_this.$store.commit('plistText',plistText);
					_this.$store.commit('rankTime',rankTime);
					_this.$store.commit('rankImgUrl',rankImgUrl);
					if(songList.length!=0){
						_this.$store.commit('setSongList',songList);
					}else{
						_this.$store.commit('setSongList',{'song':{'title':'服务器无数据返回，我也没办法 o(╯□╰)o，点其它歌单的吧...'}});
					}
					_this.$store.commit('setGuodu',false);
				},300);
				//_this.songList=songList;

			},
			error:function(){
				alert(-1)
			}
		});
		this.$router.push({path: '/plistPage'})
      },
    }
 }
</script>

<style>
@import url("../assets/swiper-3.4.0.min.css");
.banner{max-width:500px;width: 100%;height:148px;position: absolute;top:112px;left:50%;transform: translateX(-50%);}
.banner img{width: 100%;}

.swiper-container {
    width: 100%;
}
.swiper-pagination-bullets{bottom:20px !important;}
.swiper-pagination-bullet-active{background: rgba(125,255,125,0.5);}
</style>


// WEBPACK FOOTER //
// banner2.vue?188f329d